// // Array navigation helpers shared across overlays that cycle focus through a list.

/**
 * Wraps `index + delta` into the range [0, length) — used for arrow-key
 * cycling through a list where reaching either end wraps to the other.
 */
export const wrapIndex = (index: number, delta: number, length: number): number => {
  if (length <= 0) return -1;
  return (index + delta + length) % length;
};

/**
 * Clamps `index + delta` into the range [0, length) — used for arrow-key
 * navigation through a row (Button Rows always, Tile Rows in most cases)
 * where reaching either end simply stops; it does not wrap to the other end.
 */
export const clampIndex = (index: number, delta: number, length: number): number => {
  if (length <= 0) return -1;
  return Math.min(Math.max(index + delta, 0), length - 1);
};
